// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".computed-wrapper[data-v-6da8c3b6] {\n  background-color: #fffbe5;\n}\n.unaffected-config[data-v-6da8c3b6] {\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
